export const PAGE_TYPE = {
    SERVICE: 'service',
} as const;

export const ELEMENT_TYPE = {
    SCHEDULING_TOOL: 'scheduling_tool',
    ITEM_DETAILS: 'item_details',
    MENU: 'menu',
    POPUP: 'popup',
} as const;

export const ELEMENT_SUBTYPE = {
    NAV_BUTTON: 'nav_button',
    NAV_TAB: 'nav_tab',
    OTHER_BUTTONS: 'other_buttons',
    DROPDOWN_MENU: 'dropdown_menu',
    DROPDOWN: 'dropdown',
    CHECKBOX: 'checkbox',
    INFORMATION_LINK: 'information_link',
} as const;

export const EVENT_ACTION = {
    CLICK: 'click',
} as const;

export const EVENT_ACTION_RESULT = {
    NEXT_STEP: 'next_step',
    CLOSE: 'close',
    OPEN: 'open',
    CHECK: 'check',
    UNCHECK: 'uncheck',
} as const;

export const FLOW_STAGE = {
    ADD_SERVICES: '4a',
    SKIP_SERVICES: '4b',
} as const;

export const FLOW_OUTCOME = {
    PROCEED: 'proceed',
    ADDED: 'added',
} as const;

export const FLOW_NAME = {
    APPOINTMENT: 'appointment',
} as const;

export const ELEMENT_TITLE = {
    SKIP_SERVICES: 'Skip Services',
    ADD_SERVICES: 'Add Services',
} as const;

export const SD_EVENT = {
    SELECTION_START: 'scheduleServiceSelectionStart',
    SELECTION_FINISH: 'scheduleServiceSelectionFinish',
} as const;
